export var DEFAULT_TEXT_SIZE = 'body1';
export var DEFAULT_ROUNDNESS = 16;